module.exports = __webpack_public_path__ + "static/media/marriage-8.6a4847da.jpg";